import { cn } from '@/lib/ui/style-helpers'

import { SegmentedControls, type SegmentedControlsProps } from './segmented-controls'

type Segment<T extends string | number> = Pick<
  SegmentedControlsProps,
  'label' | 'icon' | 'counter' | 'aria-label'
> & { value: T }

export interface SegmentedControlGroupProps<T extends string | number> {
  segments: Array<Segment<T>>
  selectedValue: T
  onSelectionChange: (value: T) => void
  disabled?: boolean
  className?: string
}

export function SegmentedControlGroup<T extends string | number>({
  segments,
  selectedValue,
  onSelectionChange,
  disabled = false,
  className,
}: SegmentedControlGroupProps<T>) {
  return (
    <div
      className={cn(
        'inline-flex w-fit items-center gap-1 rounded bg-palette-opacity-gray-dark p-0.5',
        className,
      )}
    >
      {segments.map(({ value, ...segment }) => (
        <SegmentedControls
          key={value}
          {...segment}
          selected={value === selectedValue}
          disabled={disabled}
          onClick={() => onSelectionChange(value)}
        />
      ))}
    </div>
  )
}
